import * as TagsConstants from "../constants/Tags";

const initialState = {
  collection: [],
  isFetching: false,
  hasLoaded: false
};

export function tags(state = initialState, action) {
  switch (action.type) {
    case TagsConstants.FETCH_STARTED:
      return {...state, isFetching: true, hasLoaded: true};
    case TagsConstants.FETCH_COMPLETED:
      return Object.assign({}, state, {
        collection: action.tags,
        isFetching: false,
        hasLoaded: true
      });
    default:
      return state;
  }
}
